import React from 'react';
import styles from './NewsAndAds.scss';
import skeletonStyles from './NewsAndAdsSkeleton.scss';

const NewsAndAdsSkeleton = () => (
  <section className={styles.container}>
    <div className={skeletonStyles.title} />
    <div className={styles.newsAndAdsLayout}>
      <div className={styles.news}>
        <ul className={styles.layout}>
          {
            [0, 0, 0, 0].map((article, index) => {
              const mainArticle = index === 0;

              return (
                <li key={`news-${index}`} className={mainArticle ? styles.mainArticle : styles.article}>
                  <div className={mainArticle ? skeletonStyles.mainArticleImageWrapper : skeletonStyles.articleImageWrapper} />
                  <div className={mainArticle ? styles.mainContent : styles.articleContent}>
                    <div className={mainArticle ? skeletonStyles.mainArticleTitle : skeletonStyles.articleTitle} />
                    <div className={styles.labelAndDate}>
                      <span className={skeletonStyles.label} />
                      <span className={skeletonStyles.date} />
                    </div>
                    <div className={mainArticle ? skeletonStyles.mainDescription : styles.articleDescription} />
                    <div className={mainArticle ? skeletonStyles.mainMoreLink : skeletonStyles.articleMoreLink} />
                  </div>
                </li>
              );
            })
          }
        </ul>
        <div className={styles.organisations}>
          <div className={skeletonStyles.organisationsLabel} />
          <div className={styles.organisationLogos}>
            <div className={skeletonStyles.logo} />
            <div className={skeletonStyles.logo} />
            <div className={skeletonStyles.logo} />
            <div className={skeletonStyles.logo} />
          </div>
        </div>
      </div>
      <div className={styles.ads} />
    </div>
  </section>
);

export default NewsAndAdsSkeleton;
